import axios from 'axios';

// const Conect = axios.create({ baseURL: 'http://192.168.100.5:3000' });
// const Conect = axios.create({ baseURL: 'http://localhost:3000' });
const Conect = axios.create({ baseURL: 'https://server.sakamottosann.com.br:1457' });

export default Conect;